/**
 * Onboarding-status in localStorage (geen server); banner op dashboard tot afgerond of overgeslagen.
 */
const KEY = 'calqtool_onboarding_v1';

export type OnboardingOutcome = 'complete' | 'skipped';

export function getOnboardingOutcome(): OnboardingOutcome | null {
  try {
    const v = localStorage.getItem(KEY);
    if (v === 'complete' || v === 'skipped') return v;
    return null;
  } catch {
    return null;
  }
}

export function isOnboardingDone(): boolean {
  return getOnboardingOutcome() !== null;
}

export function markOnboardingComplete(): void {
  try {
    localStorage.setItem(KEY, 'complete');
  } catch {
    /* ignore */
  }
}

export function markOnboardingSkipped(): void {
  try {
    localStorage.setItem(KEY, 'skipped');
  } catch {
    /* ignore */
  }
}

export function resetOnboarding(): void {
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
}
